var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"quill-editor"},[_vm._t("toolbar"),_vm._v(" "),_c('div',{ref:"editor",staticClass:"quill-editor-textarea"}),_vm._v(" "),_c('div',{staticStyle:{"background-color":"red"},attrs:{"id":"counter"}},[_vm._v("0")])],2)
}
var staticRenderFns = []

export { render, staticRenderFns }